/* ============================================================
   Criterion Industries — Event photo gallery
   Progressive enhancement only. With JS disabled: every album is
   visible, the filter chips stay hidden, and each tile is a plain
   link to the full-size image.

   Does four things:
     1. orientation auto-detect for tiles whose ratio wasn't known server-side
     2. album filter chips (+ #album-<key> / ?album=<key> deep links)
     3. lightbox with keyboard + wrap-around navigation, scoped to one album
     4. entrance reveal
   ============================================================ */
(function () {
  var root = document.querySelector('[data-eg-root]');
  if (!root) return;

  root.classList.add('eg-ready');

  var albums = Array.prototype.slice.call(root.querySelectorAll('.eg-album[data-eg-album]'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-eg-filter]'));
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Orientation auto-detect ----------------------------------
     Tiles rendered from a pasted URL have no known aspect ratio, so Liquid
     marks them data-eg-autosize and falls back to the landscape tile.

     The tile images are lazy-loaded, so waiting on their `load` event would
     resize tiles as the visitor scrolls — the grid would visibly jump. Instead
     probe a 20px-wide copy of each image straight away: on the Shopify CDN
     `&width=20` returns a thumbnail with the same aspect ratio for a few
     hundred bytes, so every tile settles at its final size during page load.
     If the probe fails we fall back to the real image's own dimensions. */
  function sizeTile(fig) {
    var img = fig.querySelector('img');
    var link = fig.querySelector('.eg-tile__btn');
    if (!img) return;
    var done = false;

    function apply(w, h) {
      if (done || !w || !h) return;
      done = true;
      fig.classList.remove('eg-tile--land', 'eg-tile--port');
      fig.classList.add(w / h < 1.12 ? 'eg-tile--port' : 'eg-tile--land');
      fig.removeAttribute('data-eg-autosize');
    }

    function fromTileImage() {
      if (img.complete) apply(img.naturalWidth, img.naturalHeight);
      else img.addEventListener('load', function () { apply(img.naturalWidth, img.naturalHeight); }, { once: true });
    }

    var src = (link && link.getAttribute('data-eg-full')) || img.getAttribute('src');
    if (!src) return fromTileImage();

    var probe = new Image();
    probe.onload = function () { apply(probe.naturalWidth, probe.naturalHeight); };
    probe.onerror = fromTileImage;
    probe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=20';
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-eg-autosize]'), sizeTile);

  /* ---------- 2. Album filters ------------------------------------------- */
  function setFilter(key, pushHash) {
    var matched = false;
    albums.forEach(function (album) {
      var show = key === 'all' || album.getAttribute('data-eg-album') === key;
      if (show && key !== 'all') matched = true;
      album.hidden = !show;
    });
    // an unknown key would blank the page — fall back to showing everything
    if (key !== 'all' && !matched) return setFilter('all', pushHash);

    chips.forEach(function (chip) {
      chip.setAttribute('aria-pressed', String(chip.getAttribute('data-eg-filter') === key));
    });

    if (pushHash && window.history && window.history.replaceState) {
      var base = window.location.pathname + window.location.search;
      window.history.replaceState(null, '', key === 'all' ? base : base + '#album-' + key);
    }
    return true;
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      setFilter(chip.getAttribute('data-eg-filter'), true);
    });
  });

  /* Deep links: #album-<key> from an event card, or ?album=<key> */
  (function applyDeepLink() {
    var key = '';
    var hash = window.location.hash || '';
    if (hash.indexOf('#album-') === 0) key = hash.slice(7);
    if (!key) {
      var m = window.location.search.match(/[?&]album=([^&]+)/);
      if (m) key = decodeURIComponent(m[1]);
    }
    if (!key) return;
    setFilter(key, false);
    var target = root.querySelector('.eg-album[data-eg-album="' + key.replace(/"/g, '') + '"]');
    if (target) {
      requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    }
  })();

  /* ---------- 3. Lightbox ------------------------------------------------ */
  var lb = root.querySelector('[data-eg-lightbox]');
  if (lb) {
    var lbImg = lb.querySelector('[data-eg-image]');
    var lbAlbum = lb.querySelector('[data-eg-lbalbum]');
    var lbCaption = lb.querySelector('[data-eg-lbcaption]');
    var lbFig = lb.querySelector('[data-eg-figcaption]');
    var lbCounter = lb.querySelector('[data-eg-counter]');
    var btnClose = lb.querySelector('[data-eg-close]');
    var btnPrev = lb.querySelector('[data-eg-prev]');
    var btnNext = lb.querySelector('[data-eg-next]');

    var group = [];      // the clicked album's tile links
    var index = 0;
    var lastFocus = null;

    function preload(src) { if (src) { var i = new Image(); i.src = src; } }

    function show(i) {
      if (!group.length) return;
      index = (i + group.length) % group.length;
      var link = group[index];
      var caption = link.getAttribute('data-eg-caption') || '';
      var album = link.getAttribute('data-eg-albumname') || '';
      var img = link.querySelector('img');

      lbImg.src = link.getAttribute('data-eg-full') || link.href;
      lbImg.alt = (img && img.getAttribute('alt')) || caption || album;
      lbAlbum.textContent = album;
      lbCaption.textContent = caption;
      lbFig.hidden = !(album || caption);
      lbCounter.textContent = (index + 1) + ' / ' + group.length;

      var single = group.length < 2;
      btnPrev.hidden = single;
      btnNext.hidden = single;

      if (!single) {
        preload((group[(index + 1) % group.length]).getAttribute('data-eg-full'));
        preload((group[(index - 1 + group.length) % group.length]).getAttribute('data-eg-full'));
      }
    }

    function open(link) {
      var album = link.closest('.eg-album');
      var scope = album || root;
      group = Array.prototype.slice.call(scope.querySelectorAll('.eg-tile__btn'));
      index = group.indexOf(link);
      if (index < 0) { group = [link]; index = 0; }

      lastFocus = link;
      lb.hidden = false;
      lb.classList.add('is-open');
      document.body.classList.add('eg-lock');
      show(index);
      btnClose.focus();
    }

    function close() {
      lb.classList.remove('is-open');
      lb.hidden = true;
      document.body.classList.remove('eg-lock');
      lbImg.src = '';
      if (lastFocus) { lastFocus.focus(); lastFocus = null; }
    }

    root.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('.eg-tile__btn') : null;
      if (!link || !root.contains(link)) return;
      e.preventDefault();          // without JS this stays a plain image link
      open(link);
    });

    btnClose.addEventListener('click', close);
    btnPrev.addEventListener('click', function () { show(index - 1); });
    btnNext.addEventListener('click', function () { show(index + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
      else if (e.key === 'Tab') {
        // keep focus inside the dialog
        var stops = [btnClose, btnPrev, btnNext].filter(function (b) { return !b.hidden; });
        var pos = stops.indexOf(document.activeElement);
        e.preventDefault();
        var nextPos = e.shiftKey ? pos - 1 : pos + 1;
        if (nextPos < 0) nextPos = stops.length - 1;
        if (nextPos >= stops.length) nextPos = 0;
        stops[nextPos].focus();
      }
    });
  }

  /* ---------- 4. Entrance reveal ----------------------------------------- */
  var revealEls = Array.prototype.slice.call(root.querySelectorAll('.reveal'));
  if (revealEls.length) {
    if (!('IntersectionObserver' in window) || reduceMotion) {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    }
  }
})();
